import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
  Typography
} from '@mui/material'
import React from 'react'
import PropTypes from 'prop-types'

const seatShape = PropTypes.shape({
  seat: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  rang: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
})

const bookingInfoShape = PropTypes.shape({
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired,
  paid: PropTypes.oneOf(['paid', 'unpaid']).isRequired
})

export default function BookingInfoDialog({ seat, bookingInfo, open, onChange, onSubmit, onCancel }) {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth='sm'>
      <DialogTitle>Informations du client</DialogTitle>
      <DialogContent>
        <Typography sx={{ mb: 1 }}>
          Siège {seat?.seat} (rang {seat?.rang})
        </Typography>
        <TextField
          autoFocus
          margin='dense'
          label='Prénom'
          fullWidth
          value={bookingInfo.firstName}
          onChange={(e) => onChange('firstName', e.target.value)}
          sx={{ mb: 1 }}
        />
        <TextField
          margin='dense'
          label='Nom'
          fullWidth
          value={bookingInfo.lastName}
          onChange={(e) => onChange('lastName', e.target.value)}
          sx={{ mb: 1 }}
        />
        <TextField
          margin='dense'
          label='Email'
          type='email'
          fullWidth
          value={bookingInfo.email}
          onChange={(e) => onChange('email', e.target.value)}
          sx={{ mb: 1 }}
        />
        <TextField
          margin='dense'
          label='Téléphone'
          fullWidth
          value={bookingInfo.phone}
          onChange={(e) => onChange('phone', e.target.value)}
          sx={{ mb: 1 }}
        />
        <Box sx={{ mt: 2 }}>
          <Typography variant='body2' sx={{ mb: 0.5 }}>
            Statut du paiement :
          </Typography>
          <RadioGroup row value={bookingInfo.paid} onChange={(e) => onChange('paid', e.target.value)}>
            <FormControlLabel value='paid' control={<Radio size='small' />} label='Payé' />
            <FormControlLabel value='unpaid' control={<Radio size='small' />} label='Non payé' />
          </RadioGroup>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Annuler</Button>
        <Button onClick={onSubmit} variant='contained' color='primary' disabled={isInvalid(bookingInfo)}>
          Marquer comme réservé
        </Button>
      </DialogActions>
    </Dialog>
  )
}

function isInvalid(info) {
  return info.paid === '' || !info.firstName || !info.lastName || !(info.email || info.phone)
}

BookingInfoDialog.propTypes = {
  seat: seatShape.isRequired,
  bookingInfo: bookingInfoShape.isRequired,
  open: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
}
